import { useSelector } from 'react-redux';
import Availability from '../../../../common/Availability';
import PropTypes from 'prop-types';

const ProductAvailability = ({ isLoading, productId, quantity }) => {
  const availability = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.availability
  );
  const sourcingDetails = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.sourcingDetails
  );
  const catEntryId = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.itemCatEntryId
  );
  const hoseAvailabilityLabel = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.hoseAvailabilityLabel
  );
  const hoseAssemblyIndicator = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.hoseAssemblyIndicator
  );
  const storeAvailability = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.storeAvailability
  );
  return (
    <Availability
      availabilityInformation={availability}
      sourcingDetailsInformation={sourcingDetails}
      catEntryId={catEntryId}
      className="mt-3"
      hideLabel={false}
      isLoading={isLoading}
      quantity={quantity}
      hoseAssemblyDetails={{ hoseAvailabilityLabel, hoseAssemblyIndicator }}
      toggleAvailability={false}
      showAdditionalInfo
      hideHeaderAndDeliveryOptions={true}
      storeAvailability={storeAvailability}
      isPDPPage
    />
  );
};

export default ProductAvailability;

ProductAvailability.propTypes = {
  isLoading: PropTypes.bool,
  productId: PropTypes.string.isRequired,
  quantity: PropTypes.string,
  showStoreAvailability: PropTypes.bool
};
